import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue';
import { BcxFormValueField } from '@/models/BcxForm';


export default /*#__PURE__*/_defineComponent({
  __name: 'BCXFormValues',
  props: {
  fields: {
    type: Array as PropType<BcxFormValueField[]>,
    default: () => []
  },
  data: {
    type: Object as PropType<Record<string, string>>,
    default: () => ({})
  },
  horizontalGap: {
    type: String,
    default: '16px'
  },
  verticalGap: {
    type: String,
    default: '16px'
  },

},
  setup(__props) {



return { __sfc: true, }
}

})